import { IntlShape } from 'react-intl';

import { NodeInfo } from '@futrli/predict/core/types';

import { NodeStaticId } from '../../../../prediction-builder/types';

/**
 * Get the display name for a system assumption row
 * @param intl - intl object (use useIntl to get this)
 * @param node - The node to get the display name for
 */
export const getSystemAssumptionDisplayName = (intl: IntlShape, node: NodeInfo) => {
  if (node.system_assumption_type === 'vat-payments') {
    return intl.formatMessage({ id: 'predict.vat_gst_payment', defaultMessage: 'VAT / GST payment' });
  }
  if (node.system_assumption_type === 'year-end') {
    return intl.formatMessage({ id: 'predict.year_end', defaultMessage: 'Year end transfer' });
  }
  if (node.system_assumption_type === 'unpaid-invoices') {
    if (node.extra_display_params?.invoices_or_bills === 'invoices') {
      return intl.formatMessage({ id: 'predict.unpaid_invoices', defaultMessage: 'Unpaid invoices' });
    }
    if (node.extra_display_params?.invoices_or_bills === 'bills') {
      return intl.formatMessage({ id: 'predict.unpaid_bills', defaultMessage: 'Unpaid bills' });
    }
  }
  return node.name;
};

/**
 * Get the display name for a top level row
 * @param nodeStaticIds - map of static ID to display names
 * @param node - The node to get the display name for
 */
export const getTopLevelRowDisplayName = (nodeStaticIds: Record<NodeStaticId, string>, node: NodeInfo) => {
  const staticId = node.static_id as NodeStaticId;
  const displayName = nodeStaticIds[staticId];
  return displayName || node.name;
};
